import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';

const IndexPage = () => (
  <Layout>
    <SEO title="Homepage" />
    <div>
      <div className="homepage-text-wrapper">
        <div className="homepage-content homepage-content__english">
          A tool to measure innovation in nanotechnology and guide strategic decision-making.
        </div>
        <div className="homepage-content homepage-content__portuguese">
          A ferramenta de medição dos níveis de inovação em nanotecnologia com o propósito de guiar
          a tomada de decisões estratégicas.
        </div>
        <div className="homepage-content homepage-content__spanish">
          Una herramienta para medir los niveles de innovación en nanotecnología,
          diseñada para guiar la toma de decisiones estratégicas.
        </div>
      </div>
      <div className="homepage-text-wrapper">
        <div className="homepage-content homepage-content__english">
          The Innovation Barometer of Nanotechnology provides open and simplified information
          from the POCTEP territory of innovation in the field of nanotechnology.
        </div>
        <div className="homepage-content homepage-content__portuguese">
          O Barometro de Inovação em Nanotecnologia disponibiliza de modo acessível
          e simplificado informações do território POCTEP em matéria de inovação nos domínios
          da nanotecnologia.
        </div>
        <div className="homepage-content homepage-content__spanish">
          El Barómetro de Innovación en Nanotecnología proporciona información accesible
          y simplificada sobre el territorio POCTEP en innovación en nanotecnología.
        </div>
      </div>
      <div className="homepage-text-wrapper">
        <div className="homepage-content homepage-content__english">
          The nanoGateway project is co-funded under the Interreg V-A Spain-Portugal Cooperation
          Programme (POCTEP)
          and is led by the INL involving the POCTEP Regional Development Agencies.
        </div>
        <div className="homepage-content homepage-content__portuguese">
          O projeto nanoGateway é cofinanciado pelo Programa de Cooperação Interreg V-A Edivha –
          Portugal (POCTEP)
          e liderado pelo INL, envolvendo as Agências de Desenvolvimento Regional da área POCTEP.
        </div>
        <div className="homepage-content homepage-content__spanish">
          El proyecto nanoGateway, cofinanciado por el Programa de Cooperación Interreg V-A España-
          Portugal (POCTEP), está liderado por el INL
          y cuenta con la participación de las Agencias de Desarrollo Regional POCTEP.
        </div>
      </div>
    </div>
  </Layout>
);

export default IndexPage;
